export default "__VITE_ASSET__BOQz7pDO__"